import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import styled from 'styled-components';

import { UserStore } from '../../stores';

import { Menu } from 'antd';
import { Link } from 'react-router-dom';

interface AccionsNavProp {
    userStore?: UserStore;
}

const AccionsNavWrapper = styled(Menu)`
    display: flex;
    flex: 1 1;
    min-width: 50px;
    border: 0 !important;
    line-height: 64px !important;
    padding-left: 20px !important;
    
    .ant-menu-submenu-selected{
        color:#000 !important;
        border-color: #a8123e !important;
    }
    .ant-menu-submenu-active{
        color:#000 !important;
        border-color: #a8123e !important;
    }
    .ant-menu-submenu-title{
        color:#000 !important;
        border-color: #a8123e !important;
    }
`;



const SubMenu = Menu.SubMenu;
const MenuItem = Menu.Item;

@inject('userStore')
@observer
export class AccionesNav extends Component<AccionsNavProp> {
    render() {
        const { userStore } = this.props;
        const { accioneGroups } = userStore!;
        const nuevaContraseña = userStore!.banderaPassword;
        return (
            <>
                {nuevaContraseña ? (
                    <AccionsNavWrapper mode="horizontal">
                        {Object.keys(accioneGroups).map(title => (
                            <SubMenu title={title} key={title}>
                                {accioneGroups[title].map(action => (
                                    <MenuItem key={action}>
                                        <Link style={{color:'#000'}}
                                            to={`/${title.toLowerCase()}/${action.toLowerCase()}`}
                                        >
                                            {action}
                                        </Link>
                                    </MenuItem>
                                ))}
                            </SubMenu>
                        ))}
                    </AccionsNavWrapper>
                ) : <AccionsNavWrapper mode="horizontal" />}
            </>
        );
    }
}
